import React from "react";
import { FlexBox, SpacingBox, ClickableBox } from "./Boxes";
import styles from "./Colors.module.scss";
import { addStyle } from "./utils";
import { labelColor } from "../utils/color";

export const styleForColorBox = (color) => ({
  backgroundColor: color,
  color: labelColor(color),
});

export const SmallColorBox = ({ color, label }) => (
  <div className={styles.smallColorBox} style={styleForColorBox(color)}>
    {label}
  </div>
);

export const RectangularColorBox = ({ color, label }) => (
  <div className={styles.rectangularColorBox} style={styleForColorBox(color)}>
    {label}
  </div>
);

export const BigColorBox = ({ color, selected, label }) => (
  <div
    className={addStyle(selected, styles.selectedBox, styles.notSelectedBox)}
  >
    <div className={styles.bigColorBox} style={styleForColorBox(color)}>
      {label}
    </div>
  </div>
);

export const SmallColors = ({ colors }) => {
  if (!colors) return null;

  return (
    <FlexBox flexWrap="wrap">
      {colors.map((color) => (
        <SpacingBox key={color.code}>
          <SmallColorBox color={color.hex} label={color.code} />
        </SpacingBox>
      ))}
    </FlexBox>
  );
};

SmallColors.defaultProps = {
  onClick: () => {},
};

export const BigColors = ({ colors, onClick }) => {
  if (!colors) return null;
  return (
    <FlexBox flexWrap="wrap">
      {colors.map((color) => (
        <SpacingBox key={color.code} marginRight="sm">
          <ClickableBox onClick={() => onClick(color.code)}>
            <BigColorBox color={color.hex} label={color.code} />
          </ClickableBox>
        </SpacingBox>
      ))}
    </FlexBox>
  );
};

BigColors.defaultProps = {
  onClick: () => {},
};
